export const deploymentQueryKeys = {
    agentSummary: (agentId: number) => ["agent-summary", agentId],
    trainingHistoryPageAll: (agentId: number) => ["training-history-page", agentId],
    deploymentHistoryPageAll: (agentId: number) => ["deployment-page", agentId]
} as const;
